function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { createElement } from "./helpers";
/**
 * Rows API
 * @param {Object} instance DataTable instance
 * @param {Array} rows
 */

export var Rows = /*#__PURE__*/function () {
  function Rows(dt, rows) {
    _classCallCheck(this, Rows);

    this.dt = dt;
    this.rows = rows;
    return this;
  }
  /**
   * Build a new row
   * @param  {Array} row
   * @return {HTMLElement}
   */


  _createClass(Rows, [{
    key: "build",
    value: function build(row) {
      var tr = createElement("tr");
      var headings = this.dt.headings;

      if (!headings.length) {
        headings = row.map(function () {
          return "";
        });
      }

      headings.forEach(function (h, i) {
        var td = createElement("td"); // Fixes #29

        if (!row[i] || !row[i].length) {
          row[i] = "";
        }

        td.innerHTML = row[i];
        td.data = row[i];
        tr.appendChild(td);
      });
      return tr;
    }
  }, {
    key: "render",
    value: function render(row) {
      return row;
    }
    /**
     * Add new row
     * @param {Array} select
     */

  }, {
    key: "add",
    value: function add(data) {
      var _this = this;

      if (Array.isArray(data)) {
        var dt = this.dt; // Check for multiple rows

        if (Array.isArray(data[0])) {
          data.forEach(function (row) {
            dt.data.push(_this.build(row));
          });
        } else {
          dt.data.push(this.build(data));
        } // We may have added data to an empty table


        if (dt.data.length) {
          dt.hasRows = true;
        }

        this.update();
        dt.columns().rebuild();
      }
    }
    /**
     * Remove row(s)
     * @param  {Array|Number} select
     * @return {Void}
     */

  }, {
    key: "remove",
    value: function remove(select) {
      var dt = this.dt;

      if (Array.isArray(select)) {
        // Remove in reverse otherwise the indexes will be incorrect
        select.sort(function (a, b) {
          return b - a;
        });
        select.forEach(function (row) {
          dt.data.splice(row, 1);
        });
      } else if (select == 'all') {
        dt.data = [];
      } else {
        dt.data.splice(select, 1);
      } // We may have emptied the table


      if (!dt.data.length) {
        dt.hasRows = false;
      }

      this.update();
      dt.columns().rebuild();
    }
    /**
     * Update row indexes
     * @return {Void}
     */

  }, {
    key: "update",
    value: function update() {
      this.dt.data.forEach(function (row, i) {
        row.dataIndex = i;
      });
    }
  }]);

  return Rows;
}();